import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Star, ExternalLink, Heart } from "lucide-react";
import { Button } from "../components/ui/button";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

// Public Google Business Profile review link.
// Update this if your GBP link changes.
const GBP_REVIEW_LINK = "https://share.google/Pkzolm8wCyYoj6Hqh";

const LeaveReview = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <SEO
        title="Leave a Review | The Sterling Touch"
        description="Loved your clean? Share your experience with The Sterling Touch — your review helps other Brisbane homeowners find us."
        path="/leave-a-review"
      />
      <header className="sticky top-0 z-40 bg-cream/95 backdrop-blur border-b border-[#e8d9cc]">
        <div className="max-w-5xl mx-auto px-6 h-20 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 text-ink hover:text-[#b8866e] transition-colors"
          >
            <ArrowLeft size={18} />
            <span className="text-sm">Back to home</span>
          </Link>
          <div className="font-brand text-base text-ink">The Sterling Touch</div>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-2xl w-full">
          <div className="text-center">
            <div className="inline-flex items-center gap-1 px-4 py-2 rounded-full bg-white border border-[#ead8c9]">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star
                  key={i}
                  size={16}
                  fill="#daae9c"
                  className="text-sterling"
                />
              ))}
            </div>
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#daae9c] mt-8">
              <Heart size={14} className="text-sterling-dark" fill="#daae9c" />
              Thank You
            </div>
            <h1 className="font-serif-display text-5xl md:text-6xl text-ink mt-4 leading-[1.05] text-balance">
              We’d love to hear{" "}
              <span className="italic text-[#daae9c]">how it went.</span>
            </h1>
            <p className="mt-6 text-lg text-ink/70 leading-relaxed max-w-xl mx-auto">
              Thank you for inviting The Sterling Touch into your home. If our
              service made a difference, a short Google review would mean the
              world to our small team — and help other Brisbane homeowners
              discover us.
            </p>

            <a
              href={GBP_REVIEW_LINK}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                // Optional analytics ping
                if (typeof window !== "undefined" && window.gtag) {
                  window.gtag("event", "review_link_click", {
                    event_category: "engagement",
                  });
                }
              }}
            >
              <Button className="mt-10 h-14 px-8 rounded-full bg-[#daae9c] hover:bg-white text-ink border border-transparent hover:border-[#daae9c] transition-colors text-base">
                Leave a Google review
                <ExternalLink size={16} className="ml-2" />
              </Button>
            </a>

            <p className="mt-4 text-xs text-ink/50">
              Opens your Google Business Profile in a new tab.
            </p>

            <div className="mt-16 p-6 bg-white rounded-2xl border border-[#ead8c9] text-left">
              <div className="text-xs uppercase tracking-[0.25em] text-[#daae9c]">
                Wasn’t quite right?
              </div>
              <div className="font-serif-display text-2xl text-ink mt-2">
                Tell us first — privately.
              </div>
              <p className="text-sm text-ink/65 mt-3 leading-relaxed">
                If something wasn’t to standard, please email{" "}
                <a
                  href="mailto:hello@thesterlingtouch.com.au"
                  className="text-[#b8866e] underline underline-offset-2"
                >
                  hello@thesterlingtouch.com.au
                </a>{" "}
                or call{" "}
                <a
                  href="tel:+61413996908"
                  className="text-[#b8866e] underline underline-offset-2"
                >
                  +61 413 996 908
                </a>
                . We’ll always make it right — and we’d rather hear it from you than online.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default LeaveReview;
